import {useEffect, useState} from 'react';
import {useArrivalContext} from 'src/context/ArrivalContext';
import {DropInQueueResponse} from 'src/services/api/types/types';
import {Spinner} from '../layout/loader/Spinner';
import {fetchDropInQueueOverview} from 'src/services/api/api';
import './DropInQueueOverview.scss';
import {useTranslation} from 'react-i18next';

export function DropInQueueOverview() {
    const {
        dataState: {clinicId, settings}
    } = useArrivalContext();
    const [queueInfo, setQueueInfo] = useState<DropInQueueResponse>();

    const {t} = useTranslation();

    useEffect(() => {
        const loadData = async function () {
            try {
                const overview = await fetchDropInQueueOverview(clinicId);
                setQueueInfo(overview);
            } catch (error) {
                console.error(error);
            }
            setTimeout(loadData, 5000);
        };

        loadData();
    }, [clinicId]);

    const fmtQueueNumber = queueInfo?.queueNumber.toString().padStart(2, '0');

    if (!queueInfo) return <Spinner />;

    return (
        <div className='dropinqueue-container'>
            <div className='dropinqueue-container__logo'>
                {settings?.logoUrl && <img src={settings?.logoUrl} height='32' alt={`${settings?.name} logo`} />}
            </div>
            <div className='dropinqueue-main'>
                {!settings?.logoUrl && <h3 className='region-name'>{settings?.name}</h3>}
                <p className='dropinqueue-main__text'>{t('arrival.dropin_now_serving')}</p>
                <p className='dropinqueue-main__queue-number'>{fmtQueueNumber}</p>
                <p className='dropinqueue-main__text'>
                    {t('arrival.dropin_expected_wait_queue', {
                        minutes: queueInfo?.expectedWait,
                        count: queueInfo?.totalInQueue
                    })}
                </p>
            </div>
        </div>
    );
}
